import './sections.css';
import Brandsection from './Brandsection';
import Section from './Section';
import ImageBrand from './image 32.png';
import Image from './man.png';

function Sections() {
  return (
    <div className='container d-lg-none d-flex flex-column align-items-center '>
      <div className='items'>
        <Section Image={Image} text='الرجال' />
        <Section Image={Image} text='الرجال' />
        <Section Image={Image} text='الرجال' />
        <Section Image={Image} text='الرجال' />
        <Section Image={Image} text='الرجال' />
        <Section Image={Image} text='الرجال' />
      </div>
      <p className='title-brand align-self-start'>Top brands</p>
      <div className='items'>
        <Brandsection Image={ImageBrand} />
        <Brandsection Image={ImageBrand} />
        <Brandsection Image={ImageBrand} />
        <Brandsection Image={ImageBrand} />
      </div>
    </div>
  )
}
export default Sections;